import { Routes } from '@angular/router';

export enum ROUTES {
  SUPPLEMENTALINFORMATIONSHEET = 'supplemental-information-sheet/:id',
  UNIFORMCIVILAFFIDAVITOFINDIGENCY = 'uniform-civil-affidavit-of-indigency/:id',
  CHILDSUPPORT = 'child-support/:id',
  NOTFOUND = 'not-found'
}

export const routes: Routes = [
    {
        path: ROUTES.SUPPLEMENTALINFORMATIONSHEET,
        title: 'Supplemental Information Sheet',
        loadComponent: () => import('./delaware/supplement-information-sheet/supplement-information-sheet.component').then(m => m.SupplementInformationSheetComponent)        
    },
    {
        path: ROUTES.UNIFORMCIVILAFFIDAVITOFINDIGENCY,
        title: 'Uniform Civil Affidavit of Indigency',
        loadComponent: () => import('./tennessee/ucai/ucai.component').then(m => m.IndigencyAffidavitComponent)        
    },
    {
        path: ROUTES.CHILDSUPPORT,
        title: 'Child Support Application',
        loadComponent: () => import('./demo/child-support-application/child-support-application.component').then(m => m.ChildSupportApplicationComponent)        
    },
    {
        path: ROUTES.NOTFOUND,
        title: 'No Template Found',
        loadComponent: () => import('./shared/not-found/not-found.component').then(m => m.NotFoundComponent)        
    },
  { path: '', redirectTo: ROUTES.NOTFOUND, pathMatch: 'full'},
  { path: '**', redirectTo: ROUTES.NOTFOUND, pathMatch: 'full' }
];
